import axios from "./axiosinstance";

const PackageApi = {
  list: () => axios.get("project-packages/list"),
  add: (payload) => axios.post("project-packages/add", payload),
  update: (payload) => axios.post("project-packages/update", payload),
  delete: (payload) => axios.post("project-packages/delete", payload),
};

export default PackageApi;